import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { GroupedTermsPlaceholders } from '../../../services/data/data-service.interface';
import { Subscription } from 'rxjs';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';

enum GroupKeys {
  BASIC = 'basic',
  AFF_SUB = 'aff_sub',
  AFF_UNIQUE = 'aff_unique',
}

@Component({
  selector: 'gtd-text-with-placeholders',
  templateUrl: './text-with-placeholders.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@DestroySubscribers()
export class TextWithPlaceholdersComponent implements OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() placeholders: GroupedTermsPlaceholders;
  @Input() customPlaceholders: FormArray;
  @Input() showExtraCustomParameter: boolean;
  public showPlaceholders = false;

  public groups = Object.values(GroupKeys);
  public placeholderGroupsLabels = {
    [GroupKeys.BASIC]: $localize`:@@common.basic:Basic`,
    [GroupKeys.AFF_SUB]: $localize`:@@common.aff_sub:Aff Sub`,
    [GroupKeys.AFF_UNIQUE]: $localize`:@@common.aff_unique:Aff Unique`,
  };
  private subscriptions: Record<string, Subscription> = {};

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.subscriptions.customPlaceholders = this.customPlaceholders.valueChanges.subscribe(() => {
      this.cd.markForCheck();
    });
  }

  public togglePlaceholders(): void {
    this.showPlaceholders = !this.showPlaceholders;
  }

  public insertPlaceholder(placeholder: string): void {
    this.control.setValue((this.control.value ?? '') + placeholder);
  }
}
